<template>
  <li class="permissions__col__body__users__list__user" :class="{index}">
    <div>
      <img :src="source.default_thumb_url"/>
      <p>{{ source.name }}</p>
    </div>
    <div class="role-change__selector role-change__selector__placeholder"
         :class="{'role-change__selector--active': source.id === activeChangeId}" :data-user-id="source.id"
         @click.stop="setChangeRole">{{ $t('vue2.permissions.change_role') }}
    </div>
  </li>
</template>

<script>
import eventbus from '../../eventbus'
import PermissionsUserChange from './PermissionsUserChange'

export default {
  name: 'item-component',
  components: {PermissionsUserChange},
  props: {
    selectableRoles: {},
    index: { // index of current item
      type: Number
    },
    source: { // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    activeChangeId () {
      return eventbus.activeChangeRoleId
    }
  },
  methods: {
    setChangeRole () {
      if (eventbus.activeChangeRoleId === this.source.id) {
        eventbus.activeChangeRoleId = null
      } else {
        eventbus.activeChangeRoleId = this.source.id
      }
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.permissions__col__body__users__list__user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}

.permissions__col__body__users__list__user:hover {
  background: aliceblue;
}

.permissions__col__body__users__list__user > div {
  display: flex;
  align-items: center;
}

.permissions__col__body__users__list__user > div > img {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  margin-right: 0.5rem;
}

.role-change__selector {
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: #f6f7f8;
  background-repeat: no-repeat;
  background-position: 100% 50%;
  background-size: 16px auto;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAALCAYAAAFpFr+XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWdJREFUeNpi6OzsjAFihv///4MxEwMDwxIg/s8ABQABxAiSBYGysjIwzcSABgACCKYCpIURRANVMiIrAAggkIIQIL0Gyj8MVGCLrIAFiGcAMTcQzwdiQ3QrQApEgPgdEOsC8VV0BQABBLLiJpBWA+IEIF6IJPcPJI/uJnQA8pU61AN9UM/8g9L6UHG8gBEUepQAgAACeeEwkLbFIgcKPQ6gF5YQ8oINEP9BE08B4tVAXEfIBUzQoGdGMiQLiGcD8Wto4OIFoGi6AMRGQHwOaggzVLMYMWEAS1vngdgEqvkVsZqpEgsAAQaKhQ9Amh+I/wJxMlpiwgYSoWEEcu1HYCwJUOIAUBA4APEbqIELoOEYj0VtGjSRzoOqfQPVy0CpA0CRKAqNyHdYHJIDtXgmNGe8huYSUaheigALEhuUEIShDtkDxIJQh8AAKHE4YSsQKA0BdABKzkLQVPkQiG8DsTYQi1PbchAAAECQW0YytHmoAAAAAElFTkSuQmCC);
  border: 1px solid #d8d8d8;
  height: 28px;
  line-height: 100%;
  padding: 0 24px 0 8px;
  color: #3d4340;
  transition: border-color 0.15s;
}

.role-change__selector:hover, .role-change__selector.role-change__selector--active {
  border-color: var(--blue);
}

</style>



// WEBPACK FOOTER //
// PermissionsUser.vue?cca40acc